import { Input } from 'antd'
import React, { useEffect, useState } from 'react'
import { BsLinkedin } from 'react-icons/bs'
import { useDispatch, useSelector } from 'react-redux'
import { setLinkedinUrl } from '../../../../redux/reducers/talentSlice'
import ContractType from '../../Profile/ProfileForm/Fields/ContractType/ContractType'
import Location from '../../Profile/ProfileForm/Fields/Location/Location'
import Remote from '../../Profile/ProfileForm/Fields/Remote/Remote'
import SalaryRange from '../../Profile/ProfileForm/Fields/SalaryRange/SalaryRange'
import SearchStatus from '../../Profile/ProfileForm/Fields/SearchStatus/SearchStatus'
import UploadResume from '../../Profile/ProfileForm/Fields/UploadResume/UploadResume'

const GeneralStep = () => {
  const dispatch = useDispatch()
  const { linkedinUrl } = useSelector((state) => state.talent)
  const [linkedinInput, setLinkedinInput] = useState('')
  const [linkedinTo, setLinkedinTo] = useState('')

  useEffect(() => {
    if (linkedinUrl?.length) {
      setLinkedinInput(linkedinUrl)
    }
  }, [linkedinUrl])

  return (
    <>
      <div className="step-content">
        <UploadResume />
        <ContractType />
        <SearchStatus />
        <Remote />
        <Location />
        <SalaryRange />
        <div className="first-step">
          <div>
            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
            <label htmlFor="linkedin" className="field-label">
              Linkedin url
              <Input
                value={linkedinInput}
                onChange={(e) => {
                  setLinkedinInput(e.target.value)
                  clearTimeout(linkedinTo)
                  setLinkedinTo(
                    setTimeout(() => {
                      dispatch(setLinkedinUrl(e.target.value))
                    }, 900),
                  )
                }}
                name="linkedin"
                prefix={<BsLinkedin color="grey" />}
                placeholder="Your Linkedin url"
              />
            </label>
          </div>
        </div>
      </div>
    </>
  )
}

export default GeneralStep
